import { render, staticRenderFns } from "./MenuSearch.vue?vue&type=template&id=f45f0b3e&scoped=true"
import script from "./MenuSearch.vue?vue&type=script&lang=js"
export * from "./MenuSearch.vue?vue&type=script&lang=js"
import style0 from "./MenuSearch.vue?vue&type=style&index=0&id=f45f0b3e&prod&scoped=true&lang=css"
import style1 from "./MenuSearch.vue?vue&type=style&index=1&id=f45f0b3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45f0b3e",
  null
  
)

export default component.exports